import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["Articles"] */ "/app/src/app/[lang]/components/Articles/Articles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Benefit"] */ "/app/src/app/[lang]/components/Benefits/Benefit/Benefit.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/components/Benefits/Benefits.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/components/DinamicMap/DinamicMap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/components/Features/Features.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/components/FormSubmit.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/components/Heading/Heading.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/components/Hero/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/components/LangRedirect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/components/Navbar/Navbar.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/components/Products/Products.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/components/Products/Product/Product.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/components/RichTextSection/RichTextSection.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/components/shared/RichHtml.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/components/shared/RichText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/components/Slider/Slider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/components/TeamMembers/TeamMembers.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/components/ui/Button/Button.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/components/ui/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/components/ui/ImageSlider/ImageSlider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/components/VideoSections/VideoSections.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/components/VideoEmbed/VideoEmbed.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/utils/SectionClient.tsx");
